var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowMoreChioces
    ? _c(
        "div",
        { staticClass: "more-recommend-border" },
        [
          _c("div", { staticClass: "more-recommend-title" }, [
            _vm._v("More Choices")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "more-data" },
            [
              _c(
                "awesome-swiper",
                {
                  attrs: {
                    pagination: _vm.pagination,
                    turnPages: _vm.turnPages,
                    swiperData: _vm.moreChoices,
                    prevName: "moreChoices",
                    nextName: "moreChoices"
                  }
                },
                _vm._l(_vm.list, function(item, index) {
                  return _c(
                    "swiper-slide",
                    { key: index },
                    [
                      _c("CardCom", {
                        attrs: {
                          data: item.moreList,
                          type: _vm.type,
                          isShowBrandTag: true,
                          isShowAddToCart: false
                        },
                        on: { buryingPoint: _vm.buryingPoint }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-divider")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bd836a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bd836a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/detail/recommend/more-recommend.vue
// module id = null
// module chunks = 